import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppStateService {

  public forceLogOut: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  states: any[] = [];

  constructor() { }


  get forcedLogOut$() {
    return this.forceLogOut.asObservable();
  }
  set forceLogout(state: boolean) {
    this.forceLogOut.next(state);
  }

  getState(state: string) { return this.states[state]; }
  setState(state: string, value: any) { this.states[state] = value; }
}
